import { render } from "./ButtonToggler.vue?vue&type=template&id=6054541c&scoped=true"
const script = {}

import "./ButtonToggler.vue?vue&type=style&index=0&id=6054541c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6054541c"]])

export default __exports__